import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Form, FormControl, FormField, FormItem } from "@/components/ui/form";
import { InputOTP, InputOTPSlot } from "@/components/ui/input-otp";
import { ToastMessage, type } from "@/lib/toastr";
import { twoFA } from "@/services/Auth.service";
import { Storage } from "@/services/storage-services";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { ChevronLeft, Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router";
import { z } from "zod";
import Logo from "../../assets/texpress.png";

export const formSchema = z.object({
  otp: z.string().max(6).min(6),
});
const TwoFA = () => {
  const location = useLocation();
  // console.log(location, "l");
  const navigate = useNavigate();
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "all",
    defaultValues: {
      otp: "",
    },
  });

  const teams = Storage.getItem("teams");

  const mutation = useMutation({
    mutationFn: (v) => twoFA(v),
    mutationKey: ["twoFA"],
    onSuccess: async (data) => {
      Storage.setItem("TreasuraAdminUserToken", data?.data?.data?.accessToken);
      Storage.setItem("env", teams[0]?.env);
      Storage.setItem("selectedMerchant", teams[0]);
      Storage.setItem("businessId", teams[0].businessId);
      if (location?.state !== null) {
        navigate(location?.state?.uri);
      } else {
        navigate({
          pathname: "/dashboard",
        });
      }

      ToastMessage(type.SUCCESS, "Welcome, you are successfully logged in");
    },
    onError: (err: any) => {
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    const v: any = {
      twoFactorAuthenticationCode: data?.otp,
    };
    await mutation.mutate(v);
  };

  return (
    <div className="flex flex-col items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col gap-6 items-center">
        <Link to="/">
          <img src={Logo} className="h-10" />
        </Link>
        <Card className="w-full lg:w-[448px] p-6">
          <CardHeader className="text-center lg:w-[358px] mx-auto">
            <CardTitle className="text-2xl font-medium">
              Enter Confirmation Code
            </CardTitle>
            <CardDescription>
              Enter the 6-digit code from your authentication device to continue
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className="grid gap-6">
                  <FormField
                    control={form.control}
                    name="otp"
                    render={({ field }) => {
                      return (
                        <FormItem>
                          <FormControl>
                            <InputOTP
                              maxLength={6}
                              {...field}
                              className="flex justify-between gap-8"
                            >
                              <InputOTPSlot index={0} className=" w-14 h-14" />
                              <InputOTPSlot index={1} className=" w-14 h-14" />
                              <InputOTPSlot index={2} className="w-14 h-14" />
                              <InputOTPSlot index={3} className=" w-14 h-14" />
                              <InputOTPSlot index={4} className=" w-14 h-14" />
                              <InputOTPSlot index={5} className="w-14 h-14" />
                            </InputOTP>
                          </FormControl>
                        </FormItem>
                      );
                    }}
                  />

                  <Button
                    type="submit"
                    variant="default"
                    className="w-full bg-gradient-to-r from-primary to-primary-2 h-14 rounded-[10px] p-[10px]"
                    disabled={
                      !form.formState.isDirty ||
                      !form.formState.isValid ||
                      form.getValues("otp") == "" ||
                      form.formState.isSubmitting ||
                      mutation.isPending
                    }
                  >
                    {mutation.isPending && (
                      <Loader2 className="text-white animate-spin" />
                    )}
                    Confirm
                  </Button>
                </div>
              </form>
            </Form>
          </CardContent>
        </Card>
        <div className="grid gap-4 text-sm font-medium text-center text-primary">
          <Link to="#" className="">
            Can&apos;t Access 2FA?
          </Link>
          <Link to="/" className="flex items-center justify-center text-center">
            <ChevronLeft className="h-4" /> Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TwoFA;
